module.exports = __webpack_public_path__ + "./assets/logo_icon__e867f3285a172031ceec458436df2f25.svg";